export const toolTypeWithInPreposition = [
  'commentDownvoted',
  'commentReported',
  'commentEdited',
  'ideaVoteCreated',
  'ideaVoteDeleted',
  'ideaUpdated',
  'markerVoteCreated',
]

export const toolTypeWithOnPreposition = [
  'commentCreated',
  'commentUpvoted',
  'guestBookCommentCreated',
  'questionCreated',
  'markerCreated',
  'markerAdded',
  'qandaQuestionAsked',
  'quickPollResponseCreated',
  'signupFormResponseCreated',
  'surveyResponseCreated',
  'storyCommentAdded',
]

export const toolTypeWithFromPreposition = [
  'commentDestroyed',
  'commentDeleted',
  'ideaReported',
  'ideaDestroyed',
  'markerReported',
]

export const toolNameWithOnPreposition = [
  'ideaVoteCreated',
  'ideaVoteDeleted',
  'markerVoteCreated',
  'markerVoteDeleted',
  'quickPollResponseUpdated',
  'storyAdded',
]

export const projectNameWithInPreposition = [
  'markerVoteDeleted',
  'quickPollResponseUpdated',
]
